import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    width: "100%",
    padding: "16px 16px",
    border: "1px solid #E4E7EC",
    borderTop: "none",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    overflowX: "auto",
  },
  buttons: {
    width: "100%",
  },
}));

export default styles;
